const CodePush = {
  sync: (_options: any, callback: (status: any) => void) => {
    callback(status);
  },
  InstallMode: {
    IMMEDIATE: 'IMMEDIATE',
  },
};

export default CodePush;